import Vue from "vue";
import Router from "vue-router";
import store from "../store/store";
import LayoutWrap from "../components/layout";
import { queryPlatformByHost } from '../services/routerApi';
import { MEMBER_REQUIRED_EVENT } from '../services/memberAccess';

let projectSetting = () => import('@/views/newItem/module/projectSetting/index.vue');
let projectDetail = () => import('@/views/projectDetail/module/detailSetting/index.vue');
let homeworkSetting = () => import("@/views/homework-manage/homework-setting");
let manage = () => import("@/views/management/index.vue");

if (haveCorpusAuditRecords) {
  projectSetting = () => import('@/views/newItem/module/projectSetting/newIndex.vue');
  projectDetail = () => import('@/views/projectDetail/module/detailSetting/newIndex.vue');
  homeworkSetting = () => import("@/views/homework-manage/homework-setting/newIndex.vue");
}
if (haveClass) {
  manage = () => import("@/views/managements/index.vue");
}

const routes = [];
routes.push(
  // {
  //   path: "/index",
  //   name: "homepage",
  //   requireAuth: false,
  //   component: () => import(`@/components/${VUE_APP_HOMEPAGE}.vue`),
  // },
  {
    path: "/",
    name: "advertise",
    redirect: VUE_APP_REDIRECT,
  },
  {
    path: "/help",
    name: "help",
    // redirect: `/help`,
    component: () => import(`@/views/help/index.vue`),
    meta: {
      // til: '译后编辑_' + VUE_APP_TITLE_NAME,
    },
  },
  {
    path: "/login",
    name: "login",
    redirect: `/login/newLogin`,
    component: () => import(`@/views/verifyLayout`),
    children: [
      {
        path: "newLogin",
        name: "newLogin",
        requireAuth: false,
        component: () => import("@/views/login/index.vue"),
      },
      {
        path: "login_in",
        name: "loginIn",
        requireAuth: false,
        component: () => import("@/views/login/index.vue"),
      },
      {
        path: "registration",
        name: "registration",
        requireAuth: false,
        component: () => import("@/views/registration/index.vue"),
      },
      {
        path: "retrievePassword",
        name: "retrievePassword",
        requireAuth: false,
        component: () => import("@/views/retrievePassword/index.vue")
      }
    ]
  },
  // 后台登录
  {
    path: "/loginBackground",
    name: "loginBackground",
    redirect: `/loginBackground/newLoginbackground`,
    component: () => import(`@/views/verifyLayoutbackground`),
    children: [
      {
        path: "newLoginbackground",
        name: "newLoginbackground",
        requireAuth: false,
        component: () => import("@/views/loginBackground/index.vue"),
      }
    ]
  },
  // {
  //       path: "/statisticalProfile",
  //       name: "statisticalProfile",
  //       component: () => import("@/views/statisticalProfile/index.vue"),
  // },
  {
    path: "/home",
    name: "home",
    component: LayoutWrap,
    redirect: "/home/homeMiddleware",
    children: [
      {
        path: "homeMiddleware",
        name: "homeMiddleware",
        component: () => import("@/components/homeMiddleware/homeMiddleware.vue"),
        meta: {},
      },
      // {
      //   path: "userManage",
      //   name: "userManage",
      //   component: () => import("@/views/userManage"),
      //   meta: {
      //     til: "用户管理_" + VUE_APP_TITLE_NAME,
      //     title: '用户管理'
      //   },
      // },
      {
        path: "personCenter",
        name: 'personCenter',
        component: () => import("@/views/personCenter"),
        meta: {
          til: "个人中心_" + VUE_APP_TITLE_NAME,
          title: '个人中心'
        }
      },
      {
        path: "myMessage",
        name: 'myMessage',
        component: () => import("@/views/myMessage"),
        meta: {
          til: "我的消息_" + VUE_APP_TITLE_NAME,
          title: '我的消息'
        }
      },
      {
        path: "myTask",
        name: "myTask",
        component: () => import("@/views/myTask/index.vue"),
        meta: {
          til: "我的任务_" + VUE_APP_TITLE_NAME,
          title: '我的任务'
        },
      },
      {
        path: "fileManage",
        name: "fileManage",
        component: () => import("@/views/file-management/index.vue"),
        meta: {
          til: "文件管理_" + VUE_APP_TITLE_NAME,
          title: "文件管理"
        }
      },
      {
        path: "fileSearch",
        name: "fileSearch",
        component: () => import("@/views/file-search/index.vue"),
        meta: {
          til: "文件检索_" + VUE_APP_TITLE_NAME,
        }
      },
      {
        path: "filePreview",
        name: "filePreview",
        component: () => import("@/views/file-preview/index.vue"),
        meta: {
          til: "文件预览_" + VUE_APP_TITLE_NAME,
        }
      },
      {
        path: 'my-homework',
        name: 'myHomework',
        component: () => import("@/views/my-homework"),
        meta: {
          til: "我的作业_" + VUE_APP_TITLE_NAME,
          title: '我的作业'
        },
      },
      {
        path: "homework-manage",
        name: "homeworkManage",
        component: () => import("@/views/homework-manage"),
        redirect: "/home/homework-manage/homework-list",
        children: [
          {
            path: "homework-list",
            name: "homeworkList",
            component: () => import("@/views/homework-manage/homework-list"),
            meta: {
              til: "作业管理_" + VUE_APP_TITLE_NAME,
              title: '作业管理'
            },
          },
          {
            path: "homework-detail",
            name: "homeworkDetail",
            component: () => import("@/views/homework-manage/homework-detail"),
            meta: {
              til: "作业详情_" + VUE_APP_TITLE_NAME,
              title: '作业管理'
            },
          },
          {
            path: "new-homework",
            name: "newHomework",
            redirect: "/home/homework-manage/new-homework/homework-info",
            component: () => import("@/views/homework-manage/new-homework/new-homework"),
            children: [
              {
                path: 'homework-info',
                name: 'HomeworkInfo',
                component: () => import("@/views/homework-manage/new-homework"),
                meta: {
                  til: "新建作业_" + VUE_APP_TITLE_NAME,
                  title: '作业管理'
                },
              },
              {
                path: "homework-setting",
                name: "homeworkSetting",
                component: homeworkSetting,
                meta: {
                  til: "作业设置_" + VUE_APP_TITLE_NAME,
                  title: '作业管理'
                },
              },
            ]
          },
        ]
      },
      {
        path: 'intelligentTranslation',
        name: 'intelligentTranslation',
        component: () => import('@/views/intelligentTranslation'),
        redirect: '/home/intelligentTranslation/textTranslation',
        children: [
          {
            path: 'textTranslation',
            name: 'textTranslation',
            component: () => import('@/views/intelligentTranslation/modules/textTranslation'),
            meta: {
              til: '文本翻译_' + VUE_APP_TITLE_NAME,
              title: '文本翻译'
            },
          },
          {
            path: 'documentTranslation',
            name: 'documentTranslation',
            component: () => import('@/views/intelligentTranslation/modules/documentTranslation'),
            meta: {
              til: '文档翻译_' + VUE_APP_TITLE_NAME,
              title: '文档翻译'
            },
          },
          {
            path: 'translationHistory',
            name: 'translationHistory',
            component: () => import('@/views/intelligentTranslation/modules/documentTranslation/translationHistory'),
            meta: {
              til: '翻译历史_' + VUE_APP_TITLE_NAME,
              title: '翻译历史'
            },
          },
          {
            path: 'translation',
            name: 'translation',
            component: () => import('@/views/intelligentTranslation/modules/documentTranslation/translation'),
            meta: {
              til: '翻译_' + VUE_APP_TITLE_NAME,
              title: '翻译'
            },
          },

        ]
      },
      {
        path: "projectHome",
        name: "projectHome",
        redirect: "/home/projectHome/fileList",
        component: () => import("@/views/projectHome"),
        children: [
          {
            path: "fileList",
            name: "fileList",
            component: () => import("@/views/projectList"),
            meta: {
              til: "项目管理_" + VUE_APP_TITLE_NAME,
              title: '项目管理'
            },
          },
        ],
      },
      {
        path: 'newItem',
        name: 'NewItem',
        component: () => import("@/views/newItem/newItem"),
        redirect: "/home/newItem/itemInfo",
        children: [
          {
            path: 'itemInfo',
            name: 'ItemInfo',
            component: () => import("@/views/newItem"),
            meta: {
              til: "新建项目_" + VUE_APP_TITLE_NAME,
              title: '项目管理'
            },
          },
          {
            path: 'projectSetting',
            name: 'ProjectSetting',
            component: projectSetting,
            meta: {
              til: "项目设置_" + VUE_APP_TITLE_NAME,
              title: '项目管理'
            }
          },
        ],
      },
      {
        path: "projectList",
        name: "ProjectList",
        component: () => import("@/views/projectList"),
        meta: {
          til: "项目管理_" + VUE_APP_TITLE_NAME,
          title: '项目管理'
        }
      },
      {
        path: "projectDetail",
        name: "ProjectDetail",
        component: () => import("@/views/projectDetail"),
        meta: {
          til: "项目详情_" + VUE_APP_TITLE_NAME,
          title: '项目管理'
        }
      },
      {
        path: 'detailSetting',
        name: 'DetailSetting',
        component: projectDetail,
        meta: {
          til: "项目设置_" + VUE_APP_TITLE_NAME,
          title: '项目管理'
        }
      },
      {
        path: 'projectStatistics',
        name: 'ProjectStatistics',
        component: () => import('@/views/projectStatistics'),
        meta: {
          til: "项目统计_" + VUE_APP_TITLE_NAME,
          title: '项目管理'
        }
      },
      {
        path: "jobManagement/studentTask",
        name: "studentTask",
        component: () => import("@/views/jobManagement"),
        meta: {
          til: "学生作业_" + VUE_APP_TITLE_NAME,
          title: '作业管理/学生作业'
        },
      },
      {
        path: "jobManagement/studentTest",
        name: "studentTest",
        component: () => import("@/views/testManagement"),
        meta: {
          til: "学生测试_" + VUE_APP_TITLE_NAME,
          title: '作业管理/学生测试'
        },
      },
      {
        path: "jobManagement/myTask",
        name: "myTestJob",
        component: () => import("@/views/myTestJob"),
        meta: {

          til: "我的作业_" + VUE_APP_TITLE_NAME,
          title: '作业测试/我的作业'
        },
      },
      {
        path: "jobManagement/myTest",
        name: "myTest",
        component: () => import("@/views/myTestJob"),
        meta: {

          til: "我的测试_" + VUE_APP_TITLE_NAME,
          title: '作业测试/我的测试'
        },
      },
      {
        path: "jobManagement/createJob",
        name: "createJob",
        component: () => import("@/views/createJob"),
        meta: {
          til: "创建作业_" + VUE_APP_TITLE_NAME,
        },
      },
      {
        path: "jobManagement/createTest",
        name: "createTest",
        component: () => import("@/views/createTest"),
        meta: {
          til: "创建测试_" + VUE_APP_TITLE_NAME,
        },
      },
      {
        path: "jobManagement/jobDetails",
        name: "jobDetails",
        component: () => import("@/views/jobDetails"),
        meta: {
          til: "作业详情_" + VUE_APP_TITLE_NAME,
        },
      },
      {
        path: "jobManagement/testDetails",
        name: "testDetails",
        component: () => import("@/views/testDetails"),
        meta: {
          til: "测试详情_" + VUE_APP_TITLE_NAME,
        },
      },
      // 普通版记忆库术语库
      {
        path: "memory",
        name: "memory",
        component: () => import("@/components/memory/memory.vue"),
        meta: {
          til: "翻译记忆", // 内部属性自定义
        },
        redirect: "/memory/memoryBank",
        // children: [
        //   {
        //     path: "memoryBank",
        //     name: "memoryBank",
        //     component: () => import('@/views/memoryBank/index.vue'),
        //     meta: {
        //       keepAlive: true,
        //       til: "翻译记忆_记忆库_" + VUE_APP_TITLE_NAME,
        //       title: '语料库/记忆库'
        //     },
        //   },
        //   {
        //     path: "memoryDetails",
        //     name: "memoryDetails",
        //     component: () => import("@/views/memoryDetails"),
        //     meta: {
        //       keepAlive: false,
        //       til: "翻译记忆详情_" + VUE_APP_TITLE_NAME,
        //       title: '翻译记忆详情'
        //     },
        //   },
        //   {
        //     path: "termBank",
        //     name: "termBank",
        //     component: () => import("@/views/termBank"),
        //     keepAlive: true,
        //     meta: {
        //       keepAlive: true,
        //       til: "翻译记忆_术语库_" + VUE_APP_TITLE_NAME,
        //       title: '语料库/术语库'
        //     },
        //   },
        //   {
        //     path: "checkTab",
        //     name: "checkTab",
        //     component: () => import("@/views/memoryDetails"),
        //     meta: {
        //       keepAlive: false,
        //       til: "翻译术语详情_" + VUE_APP_TITLE_NAME,
        //       title: '翻译术语详情'
        //     },
        //   }
        // ],
        children: [
          {
            path: "memoryBank",
            name: "memoryBank",
            component: () => import('@/views/corpus/memoryBank/index.vue'),
            meta: {
              keepAlive: true,
              til: "翻译记忆_记忆库_" + VUE_APP_TITLE_NAME,
              title: '语料库/记忆库'
            },
          },
          {
            path: "corpusmemoryDetail",
            name: "corpusmemoryDetail",
            component: () => import("@/views/corpus/corpusDetail/index.vue"),
            meta: {
              keepAlive: false,
              til: "翻译记忆详情_" + VUE_APP_TITLE_NAME,
              title: '翻译记忆详情'
            },
          },
          {
            path: "termBank",
            name: "termBank",
            component: () => import("@/views/corpus/termBank"),
            keepAlive: true,
            meta: {
              keepAlive: true,
              til: "翻译记忆_术语库_" + VUE_APP_TITLE_NAME,
              title: '语料库/术语库'
            },
          },
          {
            path: "corpustermbankDetail",
            name: "corpustermbankDetail",
            component: () => import("@/views/corpus/corpusDetail/index.vue"),
            meta: {
              keepAlive: false,
              til: "翻译术语详情_" + VUE_APP_TITLE_NAME,
              title: '翻译术语详情'
            },
          },
          {
            path: "retrieval",
            name: "retrieval",
            component: () => import("@/views/corpus/retrieval/index.vue"),
            keepAlive: true,
            meta: {
              keepAlive: true,
              til: "检索_" + VUE_APP_TITLE_NAME,
              title: '检索'
            },
          }
        ],
      },
      // 审核记录版记忆库术语库
      {
        path: "corpus",
        name: "corpus",
        component: () => import("@/components/memory/index.vue"),
        meta: {
          til: "翻译记忆", // 内部属性自定义
        },
        redirect: "/corpus/memoryLib",
        children: [
          {
            path: "memoryLib",
            name: "memoryLib",
            component: () => import('@/views/TranslationMemory/memoryBank/index.vue'),
            meta: {
              keepAlive: true,
              til: "翻译记忆_记忆库_" + VUE_APP_TITLE_NAME,
              title: '语料库/记忆库'
            },
          },
          {
            path: "wareMemoryDetail",
            name: "wareMemoryDetail",
            component: () => import("@/views/TranslationMemory/corpusDetail/index.vue"),
            meta: {
              keepAlive: false,
              til: "翻译记忆详情_" + VUE_APP_TITLE_NAME,
              title: '翻译记忆详情'
            },
          },
          {
            path: "termLib",
            name: "termLib",
            component: () => import("@/views/TranslationMemory/termBank/index.vue"),
            keepAlive: true,
            meta: {
              keepAlive: true,
              til: "翻译记忆_术语库_" + VUE_APP_TITLE_NAME,
              title: '语料库/术语库'
            },
          },
          {
            path: "wareTermbankDetail",
            name: "wareTermbankDetail",
            component: () => import("@/views/TranslationMemory/corpusDetail/index.vue"),
            meta: {
              keepAlive: false,
              til: "翻译术语详情_" + VUE_APP_TITLE_NAME,
              title: '翻译术语详情'
            },
          },
          // {
          //   path: "tarnslationList",
          //   name: "tarnslationList",
          //   component: () => import('@/views/TranslationMemory/tarnslationList.vue'),
          //   meta: {
          //     keepAlive: true,
          //     til: "语料库库列表_" + VUE_APP_TITLE_NAME,
          //     title: '语料库列表'
          //   },
          // },
          {
            path: 'warehousingAudit',
            name: 'warehousingAudit',
            component: () => import('@/views/TranslationMemory/warehousingAudit'),
            meta: {
              keepAlive: false,
              til: "入库审核记录" + VUE_APP_TITLE_NAME,
              title: '入库审核记录'
            },
          },
          {
            path: 'bilingualAlignment',
            name: 'bilingualAlignment',
            component: () => import('@/views/bilingual-alignment/index.vue'),
            meta: {
              til: '双语对齐_' + VUE_APP_TITLE_NAME,
            },
          },
          {
            path: "alignRecords",
            name: "alignRecords",
            component: () => import("@/views/bilingual-alignment/alignRecords/index.vue"),
            meta: {
              keepAlive: false,
              til: "对齐记录_" + VUE_APP_TITLE_NAME,
              title: '对齐记录'
            },
          },
          {
            name: 'alignRecordsDetail',
            path: '/alignRecordsDetail',
            component: () => import('@/views/bilingual-alignment/index.vue'),
            meta: {
              til: '双语对齐_' + VUE_APP_TITLE_NAME,
            },
          },
          // {
          //   path: 'reviewDetails',
          //   name: 'reviewDetails',
          //   component: () => import('@/views/reviewDetails'),
          //   meta: {
          //     keepAlive: false,
          //     til: "审核详情" + VUE_APP_TITLE_NAME,
          //     title: '审核详情'
          //   },
          // },
        ],
      },
      {
        path: "manage",
        name: "manage",
        component: () => import("@/views/management/index.vue"),
        meta: {
          til: "团队管理_" + VUE_APP_TITLE_NAME,
          title: '团队管理'
        },
      },
      {
        path: "managementclass",
        name: "managementclass",
        component: manage,
        meta: {
          til: "团队管理_" + VUE_APP_TITLE_NAME,
          title: '团队管理'
        },
      },
      {
        path: "classdetail",
        name: "classdetail",
        component: () => import("@/views/managements/module/managementClass/classDetail/index.vue"),
        meta: {
          til: "班级详情" + VUE_APP_TITLE_NAME,
          title: '班级详情'
        },
      },
      {
        path: "myclassdetail",
        name: "myclassdetail",
        component: () => import("@/views/managements/module/myClass/myClassDetail/index.vue"),
        meta: {
          til: "我的班级详情" + VUE_APP_TITLE_NAME,
          title: '我的班级详情'
        },
      },
      {
        path: "classdetail/studentdetail",
        name: "studentdetail",
        component: () => import("@/views/managements/module/managementClass/classDetail/modules/studentDetail/index.vue"),
        meta: {
          til: "学生详情" + VUE_APP_TITLE_NAME,
          title: '学生详情'
        },
      },
      {
        path: "statistics",
        name: "statistics",
        component: () => import('@/views/managerStatistics/index.vue'),
        meta: {
          til: "统计_" + VUE_APP_TITLE_NAME,
          title: '统计'
        },
      },
    ],
  },

  {
    path: '/translationDetail',
    name: 'translationDetail',
    component: () => import('@/views/intelligentTranslation/modules/documentTranslation/editor'),
    meta: {
      til: '翻译详情_' + VUE_APP_TITLE_NAME,
    },
  },
  {
    path: "/newEditor",
    name: "newEditor",
    component: () => import("@/components/editor/newEditor.vue"),
    meta: {
      til: "译后编辑_" + VUE_APP_TITLE_NAME,
    },
  },
  {
    path: '/wordEditorTier',
    name: 'wordEditorTier',
    component: () => import('@/components/editor/modules/editorArea/modules/editorContrast/wordEditorTier.vue'),
    meta: {
      til: '译后编辑_' + VUE_APP_TITLE_NAME,
    },
  },
  //蒙语编辑
  {
    path: '/mongoEditor',
    name: 'mongoEditor',
    component: () => import('@/components/editor/modules/editorArea/modules/editorContrast/editormongoTab.vue'),
    meta: {
      til: '译后编辑_' + VUE_APP_TITLE_NAME,
    },
  },
  {
    path: '/editorXls',
    name: 'editorXls',
    component: () => import('@/components/editor/modules/editorArea/modules/editorContrast/editorXlsx.vue'),
    meta: {
      til: '译后编辑_' + VUE_APP_TITLE_NAME,
    },
  },
  {
    path: '/editor',
    name: 'editor',
    component: () => import('@/components/editor/modules/editorArea/modules/editorContrast/editor.vue'),
    meta: {
      til: '译后编辑_' + VUE_APP_TITLE_NAME,
    },
  },
  {
    path: "*",
    component: () => import("@/views/publicity/index.vue"),
  },
);

Vue.use(Router);

export const router = new Router({
  routes,
  linkActiveClass: "current",
});

const MEMBER_ROUTE_EXEMPT_PREFIXES = ["/login", "/loginBackground", "/help"];
const MEMBER_ROUTE_ALWAYS_ALLOWED = ["/home/homeMiddleware", "/home/personCenter"];

const normalizeRoutePath = (path = "") => {
  const normalized = String(path).split("?")[0].replace(/\/$/, "");
  return normalized || "/";
};

const collectMenuRoutePaths = (menuList = [], paths = []) => {
  menuList.forEach((menu) => {
    if (menu && menu.url) paths.push(normalizeRoutePath(menu.url));
    if (menu && Array.isArray(menu.children)) {
      collectMenuRoutePaths(menu.children, paths);
    }
  });
  return paths;
};

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("userInfo") || localStorage.getItem("myUser") || "{}");
  } catch (e) {
    return {};
  }
};

const isMemberRouteExempt = (path) => {
  const normalizedPath = normalizeRoutePath(path);
  return normalizedPath === "/" || MEMBER_ROUTE_EXEMPT_PREFIXES.some(
    (prefix) => normalizedPath === prefix || normalizedPath.indexOf(`${prefix}/`) === 0
  );
};

const isAllowedNonMemberRoute = (path, menuList) => {
  const normalizedPath = normalizeRoutePath(path);
  return MEMBER_ROUTE_ALWAYS_ALLOWED.includes(normalizedPath) ||
    collectMenuRoutePaths(menuList).includes(normalizedPath);
};

// 前置守卫:判断是否需要登录权限 以及是否登录---该函数 在路由跳转之后,组件渲染（加载）之前-执行
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.til || VUE_APP_TITLE_NAME;

  // 面对单点登录没有退出关闭网页，再次打开浏览器后报平台编码为空问题
  if (CAS_ENABLE && !localStorage.companyCode && to.name !== 'homeMiddleware') {
    if (to.name === 'help') {
      next();
      return;
    }
    next({ name: "homeMiddleware" });
    return;
  }

  if (!localStorage.myPlatformType && VUE_PLATFORM_TYPE === 'demo') {
    const { success, result, resultCode } = await queryPlatformByHost({
      host: window.location.host,
      // host: 'bistu.fycat.com',
    });
    const { title } = result;
    if (success && resultCode === '1' && title) {
      document.title = title + "人机合译教学实践平台";
      localStorage.setItem("myPlatformType", result.platformType);
      localStorage.setItem("myAppTitle", result.title);
      // icon图标
      // 没有就默认为public文件夹下的logo
      if (result.faviconIcon) {
        localStorage.setItem("myFaviconIcon", result.faviconIcon);
      } else {
        localStorage.setItem("myFaviconIcon", "./logo.ico");
      }
      // 登录页左上角图标
      localStorage.setItem("myLoginLogoPic", result.loginLogoPic);
      // layout左上角图标
      localStorage.setItem("myLogoPic", result.logoPic);
      // 登录页登录左侧图案
      localStorage.setItem("myLoginSloganPic", result.loginSloganPic);
      localStorage.setItem("sourceAppid", result.sourceAppid);

      if(result.sourceAppid){
        SOURCE_APPID = result.sourceAppid;
        console.log("SOURCE_APPID", SOURCE_APPID)
      }
    }
  } else if (VUE_PLATFORM_TYPE === 'demo') {
    document.title = localStorage.myAppTitle + "人机合译教学实践平台";
    if(!SOURCE_APPID){
      SOURCE_APPID = localStorage.getItem("sourceAppid") || '';
    }
  }

  if (!isMemberRouteExempt(to.path)) {
    let userInfo = store.getters["layout/getUserInfo"] || {};
    if (!userInfo.id) userInfo = getStoredUser();

    if (userInfo.id) {
      const memberInfo = await store.dispatch(
        "layout/checkMembership",
        userInfo.id
      );

      if (memberInfo.active !== true) {
        let menuList = store.getters["layout/getNavInfo"] || [];
        if (!menuList.length) {
          const companyCode =
            (userInfo.lastSelectCompany && userInfo.lastSelectCompany.code) ||
            localStorage.getItem("companyCode") ||
            localStorage.getItem("myCompanyCode");
          if (companyCode) {
            await store.dispatch("layout/navInfo", companyCode);
            menuList = store.getters["layout/getNavInfo"] || [];
          }
        }

        if (!isAllowedNonMemberRoute(to.path, menuList)) {
          window.dispatchEvent(
            new CustomEvent(MEMBER_REQUIRED_EVENT, { detail: memberInfo })
          );
          if (from && from.name) {
            next(false);
          } else {
            next({
              name: "personCenter",
              replace: true,
            });
          }
          return;
        }
      }
    }
  }

  if (to.path === "/neweditor") {
    await store.dispatch('editor/userInfo').then((resp) => {
      if ((resp.status) === 200 && (resp.success)) {
        let result = resp.result;
        if (parseInt(result.guideProgress) === 4) {
          store.commit("setIsNovice", true);
          store.commit("setNumOfGuide", 4)
        }
        localUseInfo(result);
      }
      store.dispatch('ws/UPDATE_LOGIN_INFO', resp);
    });
  }
  next();
});

export const localUseInfo = (data) => {
  localStorage.setItem("myUser", JSON.stringify(data));
  localStorage.setItem("userInfo", JSON.stringify(data));
  // localStorage.setItem("companyCode", data.lastSelectCompany.code); // 公司编码
  // localStorage.setItem("myCompanyCode", data.lastSelectCompany.code); // 公司编码
};

// 解决相同路径调整报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router